

// https://support.maestrooo.com/article/304-technical-javascript-events-exposed-by-the-theme

document.addEventListener('variant:change', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let previousVariant = event.detail.previousVariant; // Gives you access to the details of the previously selected variant
    let product = event.detail.product; // Gives you access to the whole product that the variant belongs to
    let form = event.target; // The form that triggers the change
    // console.log('VARIANT CHANGED');
  });


  


function isProductPage() {
    return window.location.pathname.includes('/products/');
}
  

if (isProductPage()) {
    // Execute code specific to product pages
    // console.log('You are on a product page.');
    } else {
    // Execute code for other pages
    // console.log('You are not on a product page.');
}

if (isProductPage()) {
    document.addEventListener('variant:change', function(event) {
        let variant = event.detail.variant;
        let variantId = variant.id;
        let modelMeasurementTags = document.getElementsByClassName('model-measurement');
        let preOrderTags = document.getElementsByClassName('js-pre-order-date');

        // MODEL MEASUREMENTS=====================
        // Hide all model measurement tags
        for (let i = 0; i < modelMeasurementTags.length; i++) {
            modelMeasurementTags[i].style.display = 'none';
        }

        // Show the corresponding model measurement tag
        for (let i = 0; i < modelMeasurementTags.length; i++) {
            let dataVariantId = modelMeasurementTags[i].getAttribute('data-variant-id');
            if (dataVariantId == variantId) {
            modelMeasurementTags[i].style.display = 'block';
            break; // Exit the loop once the corresponding tag is found
            }
        }

        // PRE ORDER DATE=========================
         // Hide all pre-order values
         for (let i = 0; i < preOrderTags.length; i++) {
            preOrderTags[i].style.display = 'none';
        }

        // Show the corresponding model measurement tag
        for (let i = 0; i < preOrderTags.length; i++) {
            let dataVariantId = preOrderTags[i].getAttribute('data-variant-id');
            if (dataVariantId == variantId) {
            preOrderTags[i].style.display = 'block';
            break; // Exit the loop once the corresponding tag is found
            }
        }

    });
}

var allowModal = false;
const addToCartButton = document.querySelector('button[data-disable-add-to-cart="true"]');
const addGCToCartButton = document.querySelector('.ProductForm__GiftCardAddToCart');
const findInStoreButton = document.querySelector('.button-find-in-store-JS');
const sizeErrorSpan = document.querySelector('.select-a-size-error');
const selectSizeMessage = document.querySelector('.ProductForm__SelectYourSize');
const chosenSize = document.querySelector('.ProductForm__SelectedValueJS');


// Function to handle the button click event
const clickEventHandler = (event) => {
    event.preventDefault(); // Prevent the default form submission
    sizeErrorSpan.style.display = "block";
    $('.select .icon-dropdown-chevron').css('inset-block-start', 'calc(50% - -12.5px)');
//   console.log('preventing');
};

// Show error message if no size chosen
document.addEventListener("DOMContentLoaded", () => {
  if (addToCartButton && sizeErrorSpan) {
    addToCartButton.addEventListener("click", clickEventHandler); // Add the event listener
    findInStoreButton.addEventListener("click", clickEventHandler); // Add the event listener
  }
});

// Remove the event listener and enable default behavior:
// When a size is selected, hide the error message and remove the event listener.
function enableDefaultBehavior() {
  if (addToCartButton && sizeErrorSpan) {
    sizeErrorSpan.style.display = "none";
    $('.select .icon-dropdown-chevron').css('inset-block-start', 'calc(50% - 3.5px)');
    addToCartButton.removeEventListener("click", clickEventHandler); // Remove the event listener
    findInStoreButton.removeEventListener("click", clickEventHandler); // Remove the event listener
  }
}



  

    

// FINAL SALE MESSAGING ON PDP and more
if (isProductPage()) {
    document.addEventListener('variant:change', function(event) {
        // if you pick the first variant it doesn't think the variant has changed because by default the first variant has been chosen
        // console.log('VARIANT CHANGED!!!!!' + event);
        let variant = event.detail.variant;
        let product = event.detail.product;
        let saleMessage = document.querySelector('.js-pdp-final-sale-msg');

        // hide or show sale message depending on variant
        if (saleMessage !== null){
            if (product.tags.includes('final-sale') || variant.compare_at_price > variant.price) {
                saleMessage.style.display = 'block';
            } else {
                saleMessage.style.display = 'none';
            }
        } 

        // launch modal if variant OOS
        if (variant.available == false){
            setTimeout(function() {
                if (allowModal){
                    document.querySelector(".klaviyo-bis-trigger").click();
                }          
            }, 500)
        }
        allowModal = false;
        updateSelectSizeMessage();

        // check if variant is pre-order
        // console.log('Variant Metafields Object:', variantMetafields);
        const metafieldData = variantMetafields[variant.id]; // Access the metafield data for the selected variant
         // Check if the metafield exists and has the desired value to show or hide the div
         toggleDivBasedOnMetafield(metafieldData ? metafieldData.pre_order : null);

    });

}

// toggle find in store on/off based on metafield data
function toggleDivBasedOnMetafield(metafieldValue) {
    const targetDiv = document.querySelector('.pickup-availability'); 
  
    // if the variant is pre-order, hide the pickup availability
    if (metafieldValue === 'Pre-Order') { 
      targetDiv.style.display = 'none';
    } else {
      targetDiv.style.display = 'inline';
    }
}
  
function updateSelectSizeMessage(){
    if (selectSizeMessage){
        // hide select a size message and show chosen size message
        selectSizeMessage.style.display = 'none'; // hides select a size
        chosenSize.style.display = 'inline-block'; // shows the size they chose
        sizeErrorSpan.style.display = "none"; // hide the error message
        // enable the add to cart button and replace text
        $('.shopify-product-form').find('button').prop('disabled', false).text('Add to cart');
        // remove select a size components
        if (addToCartButton) {
            addToCartButton.removeAttribute('data-disable-add-to-cart'); // Remove the data attribute
        } else {
            // console.error('addToCartButton is not found in the DOM.');
        }        
        enableDefaultBehavior();
        // hide fake find in store button
        $('.button-find-in-store-JS').css('display', 'none');
        $('.button-find-in-store').css('display', 'block');
    }
}

  
// ------------------------------------------------------------------------------------------------------------------
// form validation for required fields on gift card page
// ------------------------------------------------------------------------------------------------------------------

/*
 * @param  {string} String to test for a valid email address
 * @return {Boolean} Email validation regex result
 */
function isEmail(email_test) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email_test);
}

/*
 * @param  {DOM Element} The form input field to validate, email or otherwise
 * @return {Boolean} Field is valid true/false
 */
function validateField(field) {

    var $this = $(field);
    var isValid = false;

    if (!$this.prop('required')) {
        isValid = true;
    } else {
        if ($this.prop('type') == 'email') {
            if (isEmail($this.val())) {
                $this.nextAll("span.error_message").hide();
                isValid = true;
            } else {
                $this.nextAll("span.error_message").show();
                isValid = false;
            }
        } else {
            if ($this.val()) {
                $this.nextAll("span.error_message").hide();
                isValid = true;
            } else {
                $this.nextAll("span.error_message").show();
                isValid = false;
            }
        }
    }
    // console.log('validate field', $this, isValid);
    return isValid;
}

/*
 * @param  {jQuery Object} Jquery form object
 * @return {Boolean} Result of form validation check
 */
function validateForm($form) {
    // console.log('validateForm() called');
    var isValid = true;
    $form.find('input').each(function() {
        validationOutput = validateField(this);
        if (validationOutput == false) {
            isValid = false;
        }
    });
    return isValid;
}

/*
 * @description Validation events
 */

// GIFT CARD check if variant was chosen
var allowGCAddToCart = false;



// if (addGCToCartButton){
//     addGCToCartButton.removeAttribute('data-disable-gc-add-to-cart'); // Remove the data attribute 
// }
// ====================


var isGiftCardPage = $('#gift-card-form').length ? true : false;
if (isGiftCardPage) {
    console.log("is gift card page!");
    
    $('input').blur(function(){
        validateField(this);
    });

    $('.ProductForm__GiftCardAddToCart').on('click', function () {
        console.log("clicked ATC BUTTON");

        var $productForm = $(this).closest('.product-info').find('form');
        var $form = $('#gift-card-form');

        // Check if the div element has the data attribute "data-disable-gc-add-to-cart" with the value "true"
        if (addGCToCartButton && addGCToCartButton.getAttribute('data-disable-gc-add-to-cart') === 'true') {
            console.log('DO NOT ALLOW');
            sizeErrorSpan.style.display = "block";
            allowGCAddToCart = false;
        } else {
            console.log('ALLOW');
            sizeErrorSpan.style.display = "none";
            allowGCAddToCart = true;
        }

        // check if size was chosen
        if (allowGCAddToCart){
            addGCToCartButton.removeAttribute('data-disable-gc-add-to-cart'); // Remove the data attribute 
            // validate form
            var isValid = validateForm($form);
        }

        if ($productForm.length > 0) {
            // console.log('form found!')
        }
        else{
            // console.log('form NOT found!')
        }

        // WIP
        // if (addGCToCartButton && sizeErrorSpan) {
        //     sizeErrorSpan.style.display = "block";
        //     console.log('preventing');
        // }
        
        if (isValid == true) {
            // console.log("this should be trigger clicking!!!")
            $productForm.find('button').trigger('click');
            $form.find('input:not([type=hidden]), textarea').each(function() {
                $(this).val('');
            });
        }
        
    });

}

// console.log('is running custom.js');
// button-mock-find-in-store-JS


if (isProductPage()) {
    //  size-selector update
    $('body').on('click', '.popover-select-size', function(){  //use size selected event instead of a click on this element
        // $('.ProductForm__SelectYourSize').css('display', 'none');
        // $('.ProductForm__SelectedValueJS').css('display', 'inline-block');   
        // // enable the add to cart button and replace text
        // $('.shopify-product-form').find('button').prop('disabled', false).text('Add to cart');
        // // remove select a size components
        // addToCartButton.removeAttribute('data-disable-add-to-cart'); // Remove the data attribute
        // sizeErrorSpan.style.display = "none"; // hide the error message
        // enableDefaultBehavior();
        // $('.button-find-in-store-JS').css('display', 'none');
        // console.log("size clicked!!!");
        // const variantPicker = document.querySelector('variant-picker');
        // variantPicker.selectVariant(7046946881597);
        // update select size message and enable add to cart button
        updateSelectSizeMessage();
        allowModal = true;
    });
    $('body').on('click', '.popover-select-title', function(){  //use size selected event instead of a click on this element
        // $('#AddToCartButton').attr('data-action', 'add-to-cart');
        // $('#AddToCartButton').removeAttr('disabled');
        // $('.ProductForm__SelectYourSize').css('display', 'none');
        // $('.ProductForm__SelectedValueJS').css('display', 'inline-block');
        // $('.ProductMeta__StoreAvailabilityContainer').css('display', 'block');
        console.log("size changed bro!!!!");
        // hide select a size message and show chosen size message
        selectSizeMessage.style.display = 'none'; // hides select a size
        chosenSize.style.display = 'inline-block'; // shows the size they chose
        sizeErrorSpan.style.display = "none"; // hide the error message

        // enable the add to cart button and replace text
        // $('.shopify-product-form').find('button').prop('disabled', false).text('Add to cart');
        // 
        // updateSelectSizeMessage();
        addGCToCartButton.removeAttribute('data-disable-gc-add-to-cart'); // Remove the data attribute 
        allowGCAddToCart = true;
    });

}